import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { Image, Typography } from "antd";
import { FundTwoTone } from "@ant-design/icons";
import { breakpoints } from "theme/media";
import { Menu, Sider } from "./elements";
import Logo from "./veikulWhite.png";

const { Item, SubMenu } = Menu;
const { Text } = Typography;
const Sidebar = ({ history, collapsed, onCollapse }) => {
  const [isLg, toggleLg] = useState(window.innerWidth > breakpoints.lg);

  const updateWidth = () => {
    toggleLg(window.innerWidth > breakpoints.lg);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, []);
  let routes = (
    <>
      <Item icon={<FundTwoTone twoToneColor={"twoToneColor"} />} key="/routes">
        <Link to="/routes">
          <Text strong style={{ color: "white" }}>
            Rutas
          </Text>
        </Link>
      </Item>
      <Item icon={<FundTwoTone twoToneColor={"twoToneColor"} />} key="/parcels">
        <Link to="/parcels">
          <Text strong style={{ color: "white" }}>
            Envíos
          </Text>
        </Link>
      </Item>

      <SubMenu
        icon={<FundTwoTone twoToneColor={"twoToneColor"} />}
        title={
          <Text strong style={{ color: "white" }}>
            Flex
          </Text>
        }
      >
        <Item
          icon={<FundTwoTone twoToneColor={"twoToneColor"} />}
          key="/flex/pickup"
        >
          <Link to="/flex/pickup">
            <Text strong style={{ color: "white" }}>
              Recoleccion
            </Text>
          </Link>
        </Item>
        <Item
          icon={<FundTwoTone twoToneColor={"twoToneColor"} />}
          key="/flex/tracking"
        >
          <Link to="/flex/tracking">
            <Text strong style={{ color: "white" }}>
              Monitoreo
            </Text>
          </Link>
        </Item>
        <Item
          icon={<FundTwoTone twoToneColor={"twoToneColor"} />}
          key="/flex/destinations"
        >
          <Link to="/flex/destinations">
            <Text strong style={{ color: "white" }}>
              Destinos
            </Text>
          </Link>
        </Item>
      </SubMenu>
      <SubMenu
        icon={<FundTwoTone twoToneColor={"twoToneColor"} />}
        title={
          <Text strong style={{ color: "white" }}>
            Next Day
          </Text>
        }
      >
        <Item icon={<FundTwoTone />} key="/history/routes">
          <Link to="/history/routes">Rutas</Link>
        </Item>
        <Item icon={<FundTwoTone />} key="/history/destinations">
          <Link to="/history/destinations">Destinos</Link>
        </Item>
        <Item icon={<FundTwoTone />} key="/history/pickups">
          <Link to="/history/pickups">Recolecciones</Link>
        </Item>
      </SubMenu>
      <Item
        icon={<FundTwoTone twoToneColor={"twoToneColor"} />}
        key="/configurations"
      >
        <Link to="/configurations">
          <Text strong style={{ color: "white" }}>
            Configuraciones
          </Text>
        </Link>
      </Item>
    </>
  );
  return (
    <Sider
      theme="dark"
      breakpoint="lg"
      collapsedWidth={isLg ? "80" : "0"}
      collapsed={collapsed}
      collapsible
      style={{
        background: "radial-gradient(ellipse at top, #000000, #142b22)",
      }}
      onCollapse={onCollapse}
    >
      <Image
        style={{
          margin: "15px auto",
          display: "block",
          paddingLeft: 40,
          paddingRight: 40,
        }}
        height={25}
        src={Logo}
        alt=""
      />
      <Menu
        theme="dark"
        style={{
          marginTop: 20,
          background: "transparent",
          paddingg: 10,
        }}
        defaultSelectedKeys={history.location.pathname.toLowerCase()}
        selectedKeys={history.location.pathname.toLowerCase()}
        mode="inline"
      >
        {routes}
      </Menu>
    </Sider>
  );
};

export default withRouter(Sidebar);
